import React from 'react';
import './LoadingOverlay.css';

interface LoadingOverlayProps {
  loading: boolean;
  text?: string;
}

function LoadingOverlay({ loading, text }: LoadingOverlayProps) {
  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-overlay-content">
        <div className="loading-spinner" />
        {text && <div className="loading-overlay-text">{text}</div>}
      </div>
    </div>
  );
}

export default LoadingOverlay;
